import gql from "graphql-tag";

export default gql`
  mutation changeSourceDisabledIA($sourceId: ID, $disabledIA: Boolean) {
    changeSourceDisabledIA(sourceId: $sourceId, disabledIA: $disabledIA) {
      id
      iaDisabled
    }
  }
`;
